var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilters(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12172_20451)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.5009 14.4395V16.6395C31.5009 17.4395 31.0009 18.4395 30.5009 18.9395L26.2009 22.7395C25.6009 23.2395 25.2009 24.2395 25.2009 25.0395V29.3395C25.2009 29.9395 24.8009 30.7395 24.3009 31.0395L22.9009 31.9395C21.6009 32.7395 19.8009 31.8395 19.8009 30.2395V24.9395C19.8009 24.2395 19.4009 23.3395 19.0009 22.8395L18.5309 22.3495C18.3775 22.1887 18.2824 21.9812 18.2607 21.7601C18.2389 21.539 18.2918 21.317 18.4109 21.1295L23.5309 12.9095C23.7109 12.6195 24.0309 12.4395 24.3809 12.4395H29.5009C30.6009 12.4395 31.5009 13.3395 31.5009 14.4395ZM23.5309 14.938L20.001 20.5005C19.661 21.0505 19.4509 23.3095 19.0009 22.8395L15.2009 18.8395C14.7009 18.3395 14.3009 17.4395 14.3009 16.8395V14.5395C14.3009 13.3395 15.2009 12.4395 16.3009 12.4395C16.3009 12.4395 24.121 12.4395 24.901 12.4395C25.681 12.4395 23.9409 14.268 23.5309 14.938Z",
    fill: "#758295"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12172_20451"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(10 10)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilters);
export default __webpack_public_path__ + "static/media/filters.91c69139d08505e6a6f6578290775044.svg";
export { ForwardRef as ReactComponent };